<template>
  <div class="box">
    <div class="columns">
      <div class="column is-6">
        <sc-field
          label="Gostaria de esconder os valores duplicados"
          prop="duplicates">
            <sc-switch v-model="quotingReturns.duplicates">
              Sim
            </sc-switch>
        </sc-field>
      </div>
    </div>
    <div >
      <sc-field label="Escolha o tipo de API">
        <div>
        <sc-radio
          v-for="types in returnAPITypes"
          :key="types.id"
          v-model="returnAPIType"
          :native-value="types.id">
          {{types.description}}
        </sc-radio>
        </div>
      </sc-field>
    </div>
    <sc-quoting-return-tbl
      :quoting-data="config_list"
      :mode-type="returnAPIType"
      :showDetails="true"
      :default-config-item="defaultConfigItem"
      :type-id="typeId"
      @getconfiglistevt="getConfigList">
        <template slot="table-fields" slot-scope="{ props }">
          <sc-table-column
            field="condition"
            label="Condição">
              <sc-field>
                <sc-select v-model="props.row.condition.value" expanded>
                  <option
                    v-for="item in srcConditionals"
                    :key="item.value"
                    :value="item.value">
                      {{ item.text }}
                  </option>
                </sc-select>
              </sc-field>
          </sc-table-column>

          <sc-table-column label="Método">
            <sc-field v-if="conditionDelivery.indexOf(props.row.condition.value) >= 0">
              <sc-select v-model="props.row.condition.param" expanded>
                <option :value="null">Todos</option>
                <option
                  v-for="method in srcMethodType"
                  :key="method.id"
                  :value="method.type">
                    {{ method.text }}
                </option>
              </sc-select>
            </sc-field>

            <sc-field v-if="props.row.condition.value === 'DM'">
              <sc-quoting-dm-all
                :call-get-dm-all="false"
                :default-value="props.row.delivery_method? props.row.delivery_method.id :1"
                v-model="props.row.condition.param"/>
            </sc-field>
          </sc-table-column>
        </template>
    </sc-quoting-return-tbl>
  </div>
</template>

<script>
  import { Lodash, Auth } from '@intelipost-js/secure-providers';
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScButton,
    ScField,
    ScSelect,
    ScSwitch,
    ScTableColumn,
    ScRadio,
  } from '@intelipost-js/secure-components';
  import ScQuotingDmAll from '../sc-quoting-dm-all/ScQuotingDmAll.vue';
  import ScQuotingReturnTbl from '../sc-quoting-return-tbl/ScQuotingReturnTbl.vue';
  import EnumMethodTypes from '../../enum/EnumMethodTypes.js';
  import EnumConditionalComplex from '../../enum/EnumConditionalComplex.js';
  import EnumReturnAPIType from '../../enum/EnumReturnAPIType.js';

  const { mapState, mapActions } = createNamespacedHelpers('quote/quotingReturn');
  export default {
    name: 'sc-quoting-return-detail',
    props: {
      returnModeType: {
        type: String,
        required: true,
      },
      typeId: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        returnAPIType: 'NORMAL',
        conditionDelivery: [
          'SLOWEST',
          'CHEAPEST',
          'FASTEST',
          'CHEAPEST_FINAL',
          'MORE_EXPENSIVE',
          'MORE_EXPENSIVE_FINAL',
        ],
        defaultConfigItem: {
          condition: {
            value: '',
            param: '',
          },
          default_new_action: {
            label: 'FIX_PRICE',
            action_condition: {
              value: 0,
              param: null,
            },
          },
          mode_type: null,
          actions: [],
          status: false,
          name: '',
          priority: 0,
          order: 0,
        },
      };
    },
    computed: {
      ...mapState([
        'quotingReturns',
      ]),
      config_list() {
        return this.quotingReturns.type_id === this.typeId ? this.quotingReturns.config_list : [];
      },
      srcMethodType() {
        return EnumMethodTypes.filter(item => item.typeReturnAPI === this.returnAPIType);
      },
      srcConditionals() {
        return EnumConditionalComplex;
      },
      returnAPITypes() {
        return EnumReturnAPIType;
      },
    },
    methods: {
      ...mapActions([
        'updateQuotingReturnsDetails',
        'getQuotingReturns',
      ]),
      getConfigList(configList) {
        this.updateQuotingReturnsDetails(
          {
            production: Auth.getUser().is_production,
            returnModeType: this.returnModeType,
            typeId: this.typeId,
            quotingReturns: Lodash.cloneDeep(this.quotingReturns),
            configList,
          },
        );
      },
    },
    components: {
      ScButton,
      ScField,
      ScSelect,
      ScSwitch,
      ScTableColumn,
      ScQuotingReturnTbl,
      ScQuotingDmAll,
      ScRadio,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/quoting-return/components/sc-quoting-return-detail/ScQuotingReturnDetail.vue